const familyProfileColorMap = {
    0: 'Primary',
    1: 'Accent1',
    2: 'Accent2',
    3: 'Additional6',
    4: 'Additional5',
    5: 'Additional1',
};
const getFamilyProfileColorIndex = (familyMemberIndex) => {
    // when remainder (jakojäännös) is zero, the familyMemberColorIndex should be five (5)
    // except when familyMemberIndex is zero, the familyMemberColorIndex should be zero (0)
    if (familyMemberIndex !== 0 && familyMemberIndex % 5 === 0) {
        return 5;
    }
    return (familyMemberIndex % 5);
};
/**
 * Family profile colors
 *
 * - Family profile has six (6) colors
 * - The first family member will have a unique color (familyMemberIndex = familyMemberColorIndex = 0, familyProfileColorMap[0])
 * - After that family members' color will loop thorugh color indexes 1 to 5 based on
 *   the remainder (jakojäännös) of familyMemberIndex
 * @example
 *    - familyMemberIndex = 7
 *    - familyMemberColorIndex = 7 % 5 = 2
 *    - familyProfileColor = familyProfileColorMap[2] = 'Accent2'
 */
export const getFamilyProfileColor = (familyMemberIndex) => {
    const familyMemberColorIndex = getFamilyProfileColorIndex(familyMemberIndex);
    const familyProfileColor = familyProfileColorMap[familyMemberColorIndex];
    return familyProfileColor;
};
